import { Pipe, PipeTransform } from "@angular/core";
import currency from "currency.js";

/*
 * Force to use plus "+" sign for numeric values
 * Usage:
 *   value | forceSign
 * Example:
 *   {{ 2 | forceSign }}
 *   formats to: +2
 */
@Pipe({ name: "forceSign" })
export class ForceSignPipe implements PipeTransform {
  transform(value: number | string): string {
    if (!value) {
      value = 0;
    }

    return +value >= 0
      ? "+" + currency(value).value
      : "" + currency(value).value;
  }
}
